/**
 * Controls expandable training module interactions.
 */
document.addEventListener('DOMContentLoaded', function() {
  const toggleButtons = document.querySelectorAll('.training-module .toggle-breakdown-container');
  toggleButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Toggle the 'open' class on the parent training module
      const trainingModule = button.closest('.training-module');
      if (trainingModule) {
        trainingModule.classList.toggle('open');
      }
      // Toggle a class on the chevron icon to rotate it
      const chevronIcon = button.querySelector('.icon-chevron-arrow');
      if (chevronIcon) {
        chevronIcon.classList.toggle('rotated');
      }
    });
  });
});